export default {  
    get: function() {
        return window.axios.get(`visitFrequency`);
    },
    update: function (data) {
        return window.axios.put(`visitFrequency`, data);
    }
}